import { useTranslation } from 'react-i18next';

const TabData07 = (t) => [
  {
    tabTitle: t('tab07.elementary'),
    featurebox: [
      {
        icon: 'line-icon-Bakelite text-[#bf8c4c] text-[50px]',
        title: t('tab07.operational_excellence'),
        content: t('tab07.content'),
      },
      {
        icon: 'line-icon-Medal-2 text-[#bf8c4c] text-[50px]',
        title: t('tab07.innovative_solutions'),
        content: t('tab07.content'),
      },
    ],
    title: t('tab07.turnaround_consulting'),
    subtitle: t('tab07.subtitle_elementary'),
    description: t('tab07.elementary_description'), // Nouvelle clé pour la description
    img: '/img/primaire.jpeg',
    buttonTitle: t('tab07.discover_service'),
    buttonLink: '/page/our-services',
    tabicons: '',
  },
  {
    tabTitle: t('tab07.basic'),
    featurebox: [
      {
        icon: 'line-icon-Archery-2 text-[#bf8c4c] text-[50px]',
        title: t('tab07.consulting_strategies'),
        content: t('tab07.content'),
      },
      {
        icon: 'line-icon-Bar-Chart2 text-[#bf8c4c] text-[50px]',
        title: t('tab07.customer_satisfaction'),
        content: t('tab07.content'),
      },
    ],
    title: t('tab07.strategic_planning'),
    subtitle: t('tab07.subtitle_basic'),
    description: t('tab07.basic_description'), // Nouvelle clé pour la description
    img: '/img/college-1.png',
    buttonTitle: t('tab07.discover_service'),
    buttonLink: '/page/our-services',
    tabicons: '',
  },
  {
    tabTitle: t('tab07.secondary'),
    featurebox: [
      {
        icon: 'line-icon-Coins text-[#bf8c4c] text-[50px]',
        title: t('tab07.finance_restructuring'),
        content: t('tab07.content'),
      },
      {
        icon: 'line-icon-Coins-3 text-[#bf8c4c] text-[50px]',
        title: t('tab07.strategy_planning'),
        content: t('tab07.content'),
      },
    ],
    title: t('tab07.investment_planning'),
    subtitle: t('tab07.subtitle_secondary'),
    description: t('tab07.secondary_description'), // Nouvelle clé pour la description
    img: '/img/lycée-1.png',
    buttonTitle: t('tab07.discover_service'),
    buttonLink: '/page/our-services',
    tabicons: '',
  },
];

export { TabData07 };